import Vue from 'vue'

export default {
	error(title, msg) {
		if(!msg) {
	        return;
	    }
	    
	    let Instance = Vue.extend({
			template:'<hz-dialog type="yellow" :title="title" :value="true" :isAutoClose="true" :isDeleteDom="true" :foot="false">' + msg + '</hz-dialog>',
			data() {
				return {
					title: title,
					msg: msg
				}
			}
		});
	    
	    let confirm = (new Instance()).$mount();

	    document.body.appendChild(confirm.$el);

	    return confirm.$el;
	},
	
	tips(msg, time, type) {
		if(!msg) {
	        return;
	    }

	    let Tips = Vue.extend({ 
	    	template:'<hz-tips :msg="msg" :time="time" :tipsType="type"></hz-tips>',
	    	data() {
	    		return {
	    			msg: msg,
	    			time: time,
	    			type: type
	    		}
	    	}
	    });

	    let ret = (new Tips()).$mount().$el;
	    // console.log('tips:', ret);
	    document.body.appendChild(ret);

	    return ret;
	},
	confirm(msg, cbOK, cbNO, title, required, autoRemove) {
		if(!msg) {
	        return;
	    }
	    let warn = this.warn;
	    let Instance = Vue.extend({
			template:'<hz-dialog :value="true" :title="title" :isAutoClose="autoRemove" :isDeleteDom="true" @cancel="cbNOHandler" @confirm="cbOKHandler">' + msg + '</hz-dialog>',
			data() {
				return {
					autoRemove: autoRemove,
					title: title || '确认信息'
				}
			},
			methods: {
				cbNOHandler() {
					cbNO && cbNO();
				},
				cbOKHandler() {
					let ipt = this.$el.querySelector('input, textarea, select');
					if(ipt) {
						let val = window.$.trim(window.$(ipt).val());
						if(required === true && !val) {
							return warn(ipt, 'required');
						}

						cbOK && cbOK(val);
						autoRemove && $(this.$el).remove();
					}
					else {
						cbOK && cbOK();
						autoRemove && $(this.$el).remove();
					}
				}
			}
		});

	    let confirm = (new Instance()).$mount();

	    document.body.appendChild(confirm.$el);

	    return confirm.$el;
	},

	loading(element, isRemove) {
		isRemove? element.classList.add('hzLoader') : element.classList.remove('hzLoader');
	},

	warn(ele, msg) {
	    ele = window.$(ele);
	    
	    var removeTips = function(ele) {
	        if(!ele) {
	            return;
	        }
	        ele = ele.target || ele.srcElement || ele;
	        ele = window.$(ele);
	        var tips = ele.data('target');
	        if(tips) {
	            tips.data('timer') && clearTimeout(tips.data('timer'));
	            tips.remove();
	            ele.data('target', null);
	        }
	    };

	    if(ele.data('target')) {
	        removeTips(ele);
	    }

	    ele.off('click', removeTips);
	    ele.on('click', removeTips);
	    ele.on('blur', removeTips);

	    var tips = window.$('<span class="hzTooltipsWarn none">' + msg + '</span>');
	    ele.after(tips);
	    tips.css('position', ele.css('position') === 'fixed'? 'fixed' : 'absolute');

	    tips.fadeIn(200, function() {
	        var timer = setTimeout(function() {
	            removeTips();
	        }, 5000);
	        tips.data('timer', timer);
	    });
	    
	    tips.css({
	        left: ele.position().left,
	        top: ele.position().top + ele.height() + 10
	    });
	    
	    ele.data('target', tips);

	    return tips;
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog.js